import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ba4ffe92"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  slot: "product-tour-preheader",
  class: "product-tour-card_image-wrapper"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  slot: "product-tour-header",
  class: "product-tour-card_title"
}
const _hoisted_4 = {
  slot: "product-tour-content",
  class: "product-tour-card_description"
}
const _hoisted_5 = {
  slot: "product-tour-next",
  class: "product-tour-card_footer flex"
}

import {computed, nextTick, ref, toRefs, watch} from 'vue';
    import {number, object} from 'vue-types';
    import {TourDefinition, useOnboardingExistingUser, useProductTour} from '..';
    import {useUser} from '@/logged/features/user';
    import TourCardIndicators from './TourCardIndicators.vue';
    import {useGlobalProperties, useVueInternals} from '@malt/vue3-use';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'TourCard',
  props: {
        tour: object<TourDefinition>().isRequired,
        tourIndex: number().isRequired,
    },
  setup(__props) {

const props = __props;

    const {$heap} = useGlobalProperties();
    const {proxy} = useVueInternals();

    

    const productTourRef = ref<HTMLJoyProductTourElement>();

    const onboardingExistingUserStore = useOnboardingExistingUser();
    const userStore = useUser();

    const isActive = computed(() => onboardingExistingUserStore.selectedOnboardingTourStepIndex === tourIndex.value);

    const {tourIndex} = toRefs(props);

    const productTourId = computed(() => `navbarTour${props.tour.navTabId}`);

    const {
        hasPreviousActiveTourStep,
        hasNextActiveTourStep,
        activeTourStepProductTourId,
        activeTourStepTarget,
        previousTourStepProductTourId,
        previousTourStepTarget,
        prepareAndGoToNextStep,
        prepareAndGoToPreviousStep,
    } = useProductTour(tourIndex);

    async function handleEndProductTour() {
        if (productTourRef.value) {
            await productTourRef.value.closeProductTour();
        }
        userStore.user!.options.onboarded = true;
    }

    watch(
        isActive,
        async (value) => {
            await nextTick();
            if (value) {
                await productTourRef.value?.componentOnReady();
                const joyIcon = productTourRef.value?.shadowRoot?.querySelector('joy-icon[name="cross"]') as HTMLJoyIconElement;
                if (joyIcon) {
                    joyIcon.style.zIndex = '3';
                }
                $heap.track(productTourId.value);
            }
        },
        {immediate: true},
    );

return (_ctx: any,_cache: any) => {
  const _component_joy_button = _resolveComponent("joy-button")!
  const _component_joy_product_tour_trigger = _resolveComponent("joy-product-tour-trigger")!
  const _component_joy_product_tour = _resolveComponent("joy-product-tour")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_component_joy_product_tour, {
      id: _unref(productTourId),
      ref_key: "productTourRef",
      ref: productTourRef,
      class: "product-tour-card",
      position: "right",
      "max-width": 400,
      spotlightPadding: 0
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("img", {
            src: _unref(onboardingExistingUserStore).selectedIllustration
          }, null, 8, _hoisted_2)
        ]),
        _createElementVNode("div", _hoisted_3, _toDisplayString(__props.tour.title), 1),
        _createElementVNode("div", _hoisted_4, _toDisplayString(__props.tour.body), 1),
        _createElementVNode("div", _hoisted_5, [
          (_unref(hasPreviousActiveTourStep))
            ? (_openBlock(), _createBlock(_component_joy_product_tour_trigger, {
                key: 0,
                "product-tour": _unref(previousTourStepProductTourId),
                target: _unref(previousTourStepTarget)
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_joy_button, {
                    variant: "ghost",
                    size: "xxsmall",
                    onClick: _unref(prepareAndGoToPreviousStep)
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$msg('navbar.tour.actions.cta.previous')), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              }, 8, ["product-tour", "target"]))
            : _createCommentVNode("", true),
          _createVNode(TourCardIndicators, { "tour-index": _unref(tourIndex) }, null, 8, ["tour-index"]),
          (_unref(hasNextActiveTourStep))
            ? (_openBlock(), _createBlock(_component_joy_product_tour_trigger, {
                key: 1,
                "product-tour": _unref(activeTourStepProductTourId),
                target: _unref(activeTourStepTarget)
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_joy_button, {
                    size: "xsmall",
                    onClick: _unref(prepareAndGoToNextStep)
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$msg('navbar.tour.actions.cta.next')), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              }, 8, ["product-tour", "target"]))
            : (_openBlock(), _createBlock(_component_joy_button, {
                key: 2,
                size: "xsmall",
                variant: "main",
                onClick: handleEndProductTour
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$msg('navbar.tour.actions.cta.confirm')), 1)
                ]),
                _: 1
              }))
        ])
      ]),
      _: 1
    }, 8, ["id"])
  ]))
}
}

})